"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tail;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _ButtonWithIcon = require("../../ButtonWithIcon");

var _ButtonWithIcon2 = _interopRequireDefault(_ButtonWithIcon);

var _Close = require("../../icon/Close");

var _Close2 = _interopRequireDefault(_Close);

var _Button = require("../../Button");

var _Button2 = _interopRequireDefault(_Button);

var _constants = require("../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Tail(_ref) {
  var children = _ref.children;
  var className = (0, _classnames2.default)('tr flex flex-row items-center', _constants.ORDER_CLASSNAMES.BULK_CHILD.RIGHT);
  return _react2.default.createElement("div", {
    className: className
  }, children);
}

Tail.Info = Info;
Tail.Toggle = Toggle;
Tail.Dismiss = Dismiss;

function Dismiss(_ref2) {
  var onClick = _ref2.onClick;
  return _react2.default.createElement(_ButtonWithIcon2.default, {
    icon: _react2.default.createElement(_Close2.default, null),
    onClick: onClick
  });
}

function Info(_ref3) {
  var children = _ref3.children;
  return _react2.default.createElement("span", {
    className: "mr4 c-muted-4"
  }, children);
}

function Toggle(_ref4) {
  var children = _ref4.children,
      button = _ref4.button,
      active = _ref4.active;
  var onClick = button.onClick,
      text = button.text;
  return _react2.default.createElement("span", {
    className: "mr2"
  }, active ? children : _react2.default.createElement(_Button2.default, {
    onClick: onClick
  }, _react2.default.createElement("span", {
    className: "ttu"
  }, text)));
}